export const PA_VERSION = "v0.9"

export const APP_VERSION = "v0.3"

export * from "./API"
export * from "./Languages"
export * from "./ErrorCode"
export * from "./Permissions"


export const ARCHIVED = 1
export const NOT_ARCHIVED = 0
export const ARCHIVED_PARAM = "active"


export const MODULES_PERMISSIONS = require("./ModulesPermissions")
